export default "__VITE_ASSET__B76tI8QZ__"